var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card-text",
    _vm._l(_vm.items, function (item, idx) {
      return _c("div", {
        key: idx,
        staticClass: "body-1 indent",
        class: {
          "numbered-indent": _vm.numberedList,
          "mb-3": _vm.spaceBetween,
        },
        domProps: { innerHTML: _vm._s(item) },
      })
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }